module.exports = __webpack_public_path__ + "img/logo-lion-parcel-red.89dcf269.svg";